import styled from "@emotion/styled"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import type { JSX, PropsWithChildren } from "react"
import { ContentWrapper } from "../contentWrapper/ContentWrapper"
import { ButtonGroup } from "../form/buttonGroup/ButtonGroup"

export const PageFooter = ({ children }: PropsWithChildren): JSX.Element => {
	return (
		<StyledContentWrapper as="footer">
			<ButtonGroup direction="row" withoutMarginTop>
				{children}
			</ButtonGroup>
		</StyledContentWrapper>
	)
}

const StyledContentWrapper = styled(ContentWrapper)`
    padding-top: ${spacingStaticMd};
    padding-bottom: ${spacingStaticMd};
`
